import React, { useCallback, useRef, useState } from 'react';
import { CustomButton } from '../Button/Button';
import Tooltip from '../Tooltip/Tooltip';

const wrapperStyles = {
    position: 'relative',
}

const TooltipButton = ({ classNameButton, classNameTooltip, tooltipText, hoverOnDisabled, disabled, ...props }) => {
    const [isHover, setIsHover] = useState(false);
    const wrapperRef = useRef(null);


    const onMouseOver = useCallback(() => {
        tooltipText?.length && (!hoverOnDisabled || disabled) && setIsHover(true);
    }, [tooltipText, hoverOnDisabled, disabled]);

    const onMouseLeave = useCallback(() => {
        tooltipText?.length && (!hoverOnDisabled || disabled) && setIsHover(false);
    }, [tooltipText, hoverOnDisabled, disabled]);

    return (
        <div style={wrapperStyles} ref={wrapperRef}>
            <CustomButton className={classNameButton} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave} disabled={disabled} {...props} />
            <Tooltip text={tooltipText} isHover={isHover} classNameTooltip={classNameTooltip} />
        </div>
    );
}

export default TooltipButton;